export default __webpack_public_path__ + "static/media/bg.f6481c63.webp";